import React from 'react';
import {
  IonModal,
  IonButton,
  IonContent,
  IonHeader,
  IonToolbar,
  IonButtons,
  IonTitle,
  IonCard,
  IonCardContent,
  IonRow,
  IonCol,
  IonList,
  IonItem,
  IonLabel,
  IonAvatar,
  IonImg,
  IonLoading
} from '@ionic/react';
import { Formik } from 'formik';
import Icon from 'src/components/Icon';
import Field from 'src/components/Field';
import app from 'src/feathers';
import alerts from 'src/lib/alerts';
import compressFile from 'src/lib/compress';

// There is a bug in IonLoading component where the message does
// not update: https://github.com/ionic-team/ionic-framework/issues/22799
// The logic is left here, but message prop is static until this is fixed

export default class DocumentsModal extends React.Component {
  state = {
    jobDocuments: [],
    editDocument: null,
    isUploading: null,
    numUploading: null
  };

  handleDidPresent = (event) => {
    // used instead of componentDidMount because the modals stay mounted
    this.getDocuments();
  };

  handleClose = () => {
    this.handleEditCancel();
    if (this.props.onClose) {
      this.props.onClose();
    }
  };

  getDocuments = () => {
    return app
      .service('api/job-documents')
      .find({ query: { job_id: this.props.jobId, $limit: 50 } })
      .then(({ data }) => this.setState({ jobDocuments: data }));
  };

  handleUploadClick = () => {
    this.input.value = null;
    this.input.click();
  };

  handleImageChange = async (event) => {
    const job_id = this.props.jobId;
    const files = Array.from(event.target.files);
    const uploads = [];
    for (const [index, file] of files.entries()) {
      try {
        this.setState({ isUploading: index + 1, numUploading: files.length });
        const compressedFile = await compressFile({ file });
        const formData = new FormData();
        formData.append(
          'file',
          new File([compressedFile], file.name, {
            lastModified: new Date()
          })
        );
        formData.append('job_id', job_id);
        await app
          .service('api/job-documents')
          .create(formData)
          .then((document) => uploads.push(document));
      } catch (error) {
        alerts.errors(error);
      }
    }
    if (uploads.length === 1) {
      return this.setState({
        editDocument: uploads[0],
        isUploading: null,
        numUploading: null
      });
    }
    this.setState({ isUploading: null, numUploading: null });
    this.getDocuments();
  };

  handleEditClick = (editDocument) => this.setState({ editDocument });

  handleEditCancel = () => this.setState({ editDocument: null });

  handleSubmit = (data, formik) => {
    const { editDocument } = this.state;
    formik.setSubmitting(true);
    app
      .service('api/job-documents')
      .patch(editDocument._id, data)
      .then((jobDocument) => {
        alerts.success('Document Updated');
        formik.setSubmitting(false);
        this.setState({ editDocument: null });
        this.getDocuments();
      })
      .catch((error) => {
        if (error.errors) {
          formik.setErrors(error.errors);
        }
        alerts.errors(error);
        formik.setSubmitting(false);
      });
  };

  handleDelete = (data, formik) => {
    formik.setSubmitting(true);
    const { editDocument } = this.state;
    app
      .service('api/job-documents')
      .remove(editDocument._id)
      .then((jobDocument) => {
        return this.getDocuments();
      })
      .then(() => {
        alerts.success('Document Removed');
        formik.setSubmitting(false);
        this.setState({ editDocument: null });
      })
      .catch((err) => {
        alerts.errors(err);
        formik.setSubmitting(false);
      });
  };

  render() {
    const { isOpen } = this.props;
    const {
      editDocument,
      jobDocuments,
      isUploading
      // numUploading
    } = this.state;
    return (
      <IonModal isOpen={isOpen} onDidPresent={this.handleDidPresent}>
        <IonHeader translucent>
          <IonToolbar>
            <IonTitle>Documents</IonTitle>
            <IonButtons slot="end">
              <IonButton onclick={this.handleClose}>Close</IonButton>
            </IonButtons>
          </IonToolbar>
        </IonHeader>
        <IonContent>
          <IonLoading
            isOpen={!!isUploading}
            // message={
            //   numUploading === 1
            //     ? 'Uploading...'
            //     : `Uploading ${isUploading} of ${numUploading}`
            // }
            message="Uploading..."
          />
          <div>
            {editDocument ? (
              <Formik
                initialValues={{
                  original_name: editDocument.original_name,
                  description: editDocument.description
                }}
                onSubmit={this.handleSubmit}
                render={(formik) => {
                  const { isSubmitting } = formik;
                  return (
                    <IonCard className="animated fadeIn fast">
                      <IonCardContent>
                        <div className="mb-3">
                          {editDocument.secure_url.includes('.pdf') ? (
                            <Icon type="image" style={{ fontSize: 100 }} />
                          ) : (
                            <IonImg
                              src={editDocument.secure_url}
                              alt="..."
                              rounded
                              className="img-fluid"
                            />
                          )}
                        </div>
                        <Field
                          label="Name"
                          name="original_name"
                          type="text"
                          rows="3"
                          disabled={isSubmitting}
                        />
                        <Field
                          label="Description"
                          name="description"
                          type="textarea"
                          rows="3"
                          disabled={isSubmitting}
                        />
                        <IonRow>
                          <IonCol size="auto">
                            <IonButton
                              color="light"
                              className="mr-2"
                              onClick={this.handleEditCancel}
                              disabled={isSubmitting}
                            >
                              Close
                            </IonButton>
                            <IonButton
                              color="danger"
                              onClick={() =>
                                this.handleDelete(formik.values, formik)
                              }
                              disabled={isSubmitting}
                            >
                              Remove
                            </IonButton>
                          </IonCol>
                          <IonCol className="ion-text-right">
                            <IonButton
                              color="success"
                              onClick={() =>
                                this.handleSubmit(formik.values, formik)
                              }
                              disabled={isSubmitting}
                            >
                              Save
                            </IonButton>
                          </IonCol>
                        </IonRow>
                      </IonCardContent>
                    </IonCard>
                  );
                }}
              />
            ) : (
              <React.Fragment>
                <div className="ion-padding">
                  <IonButton
                    color="light"
                    expand="block"
                    onClick={this.handleUploadClick}
                    disabled={isUploading}
                  >
                    <Icon type="upload" className="mr-3" />
                    Upload
                  </IonButton>
                  <input
                    type="file"
                    multiple
                    accept=".jpg, .png, .pdf, .jpeg"
                    style={{ display: 'none' }}
                    ref={(ref) => (this.input = ref)}
                    onChange={this.handleImageChange}
                  />
                </div>
                <IonList>
                  {jobDocuments.length > 0 &&
                    jobDocuments.map((jobDocument) => (
                      <IonItem
                        key={jobDocument._id}
                        onClick={() => this.handleEditClick(jobDocument)}
                      >
                        <IonAvatar slot="start">
                          <a
                            href={jobDocument.secure_url}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {jobDocument.secure_url.includes('.pdf') ? (
                              <Icon type="image" style={{ fontSize: 100 }} />
                            ) : (
                              <IonImg src={jobDocument.secure_url} alt="..." />
                            )}
                          </a>
                        </IonAvatar>
                        <IonLabel>
                          <h2>{jobDocument.original_name}</h2>
                          <p>
                            Uploaded:{' '}
                            {jobDocument.user
                              ? jobDocument.user.full_name
                              : 'NA'}
                          </p>
                          <p style={{ whitePpace: 'pre-line' }}>
                            Desc: {!jobDocument.description && 'NA'}
                            {jobDocument.description &&
                            jobDocument.description.length >= 150
                              ? jobDocument.description.substring(0, 150) +
                                '...'
                              : jobDocument.description}
                          </p>
                        </IonLabel>
                      </IonItem>
                    ))}
                </IonList>
              </React.Fragment>
            )}
          </div>
        </IonContent>
      </IonModal>
    );
  }
}
